import $ from 'jquery';

export default function () {
    $("#popup").on("click", function (e) {
        e.preventDefault();
        $('#popup__wrapper').toggleClass('absolute');
    });
    $("#popup__close").on("click", function (e) {
        e.preventDefault();
        $('#popup__wrapper').toggleClass('absolute');
    });
}
